// extracted by mini-css-extract-plugin
export default {"container":"tCCzFsUzXZZrgGQcB7ka5g==","headline":"YnPpnevik0yie4EMFKxfeQ==","shareButtons":"_7S5OrEOg0rSu7kouZnqliw=="};